export default __webpack_public_path__ + "static/media/google_sheets.45e0c918.svg";